<template>
	<div style="background-color: #fff">
		<!--header-->
		<header class="header-top">
			<img src="../../images/orgChannelLogo.png" alt="" class="channelLogo" v-if="logo == 0" />
			<img src="../../images/unorgChannelLogo.png" alt="" class="channelLogo" v-if="logo == 1" />

			<router-link :to="'/notice'" v-if="logo < 0"><i class="iconfont noticeIcon"></i></router-link>
			<router-link :to="'/search'"><input type="text" :class="isORG ? 'searchinputOrg' : 'searchinput'" placeholder="请输入关键词" /></router-link>
			<router-link :to="'/notice'" v-if="isORG"><i class="iconfont noticeIcon"></i></router-link>
			<span :class="isORG ? 'iconfont icontOrg' : 'iconfont icont'">&#xe64b;</span>
			<span><i class="iconfont serverIcon"></i></span>
		</header>
		<div class="home" :style="style">
			<!--banner-->
			<div class="banner">
				<div class="swiper-container swiper-banner" v-if="bannerList && bannerList.length > 0">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item, index) in bannerList" v-if="index < 3">
							<a :href="item.actionUrl"><img :src="item.location" /></a>
						</div>
					</div>
					<!-- Add Pagination -->
					<div class="swiper-pagination"></div>
				</div>
			</div>

			<!-- categoryList -->
			<div class="categoryList">
				<div class="tabHeader">
					<ul>
						<li :class="{ categoryActive: 0 == categoryActive }" @click="checkCategoryActive(0)">
							推荐
							<i></i>
						</li>
						<li
							v-for="(item, index) in categoryList"
							:key="item.id"
							:class="{ categoryActive: index + 1 == categoryActive }"
							@click="checkCategoryActive(index + 1, item.id)"
						>
							{{ item.categoryName }}
							<i></i>
						</li>
					</ul>
				</div>
				<div class="tabBody">
					<transition name="router-fade" mode="out-in">
						<div class="gameBox">
							<!-- gameId=1109&gameName=王者荣耀&gameType=2 -->
							<router-link
								class="boxItem"
								:to="{
									path: '/goodslist',
									query: {
										gameId: item.game_id || item.gameId,
										gameName: item.name || item.gameName,
										gameType: item.game_type || item.gameType
									}
								}"
								v-for="item in isORG ? tabListOrg : tabList"
								:key="item.game_id || item.gameId"
							>
								<div class="images">
									<img :src="item.logo_url || item.imgUrl" alt="" />
								</div>
								<div class="tit">{{ item.name || item.gameName }}</div>
							</router-link>
							<router-link
								class="boxItem"
								v-if="isORG"
								:to="{
									path: '/goodsAll'
								}"
							>
								<div class="images">
									<img src="../../images/allGame.png" alt="" />
								</div>
								<div class="tit">全部游戏</div>
							</router-link>
						</div>
					</transition>
				</div>
				<router-link class="moreIcon" :to="{ path: '/goodsAll' }"></router-link>
			</div>

			<!-- boonCenter -->
			<div class="boonCenter" v-if="boonCenterData.length > 0">
				<div class="title">福利中心</div>
				<div class="content">
					<div v-for="item in boonCenterData" :key="item.id">
						<a :href="item.actionUrl"><img :src="item.location" alt="" /></a>
						<!-- <p v-if="item.properties.tab">
              {{ item.properties.tab }}
            </p> -->
					</div>
				</div>
			</div>
			<!-- 新增banner新人入口 -->
			<div class="bannerImgEnter" v-if="isORG && $store.state.userInfo">
				<div @click="gonewPeopleActivity">
					<img src="../../images/orgChannelEnter.png" alt="" class="orgChannelImg" />
				</div>
			</div>
			<router-link
				class="bannerImgEnter"
				v-if="isORG && !$store.state.userInfo"
				:to="{
					path: '/login',
					query: {
						redirect: '/'
					}
				}"
			>
				<img src="../../images/orgChannelEnter.png" alt="" class="orgChannelImg" />
			</router-link>

			<div class="gameList">
				<van-tabs v-model="tabsActive" sticky :offset-top="'0.85rem'" @change="checkGameActive" :class="isShowSort && 'sort-tabs'">
					<van-tab v-for="(item, index) in gameList" :title="item.title" :key="item.gameId">
						<van-list v-model="loading" :finished="finished" finished-text="没有更多啦!" loading-text=" " @load="queryGoodsList" v-if="tabsActive == index">
							<ul class="shop_list">
								<li
									v-for="(item, index) in goodsList"
									:key="index"
									:data-index="item.stickorder ? index : 'null'"
									:data-gameId="item.game_id"
									:data-goodId="item.goods_id"
								>
									<router-link
										:to="{
											path: 'goodsdetail',
											query: {
												goodsId: item.id,
												gameId: item.game_id,
												stickorder: item.stickorder, // 置顶埋点用
												itemIndex: index, // 置顶埋点用
												pageSource: 1 // 页面埋点 用户访问来源：1.首页 2.商品列表 3.其他
											}
										}"
									>
										<div class="img">
											<img :src="item.imageurl" alt="" />
											<span class="game_login_type" v-show="item.gameLoginType >= 0">{{ item.shfs }}</span>
											<i
												v-show="item.gameAccountType == 2 || item.gameAccountType == 3"
												:class="[{ loginTypeQQ: item.gameAccountType == 2 }, { loginTypeWx: item.gameAccountType == 3 }]"
											></i>
										</div>
										<div class="inner">
											<!-- <h3 class="game_name"><span v-if="item.signseller=='1'">签</span>{{ item.goods_title }}</h3> -->
											<h3 class="game_name">
												<span v-if="item.stickorder == '1'" class="stickorderIcon"></span>
												<span v-if="item.isCompensate == '0'" class="isCompensateIcon"></span>
												{{ item.goods_title }}
											</h3>
											<h3 class="game_area">{{ item.game_all_name }}</h3>
											<p class="protoParams">
												<template>
													<span v-for="(v, k, i) in protoParams" :key="i" v-if="item.protoParams[v]">
														{{ k + item.protoParams[v] }}
													</span>
												</template>
											</p>
											<!-- <p class="game_area">{{ item.search_title }}</p> -->
											<div class="game_price">
												<div class="lf">
													<i>¥</i>
													<em>{{ item.lease_price }}</em>
													/小时
												</div>
												<span class="hot_value">商品热度{{ item.hot_value }}</span>
											</div>
											<div class="activity">
												<span v-if="item.short_lease">{{ item.short_lease }}小时起租</span>
												<span v-if="item.foregift">押金{{ item.foregift.toFixed(2) }}元</span>
												<span v-if="item.deadLineOnLine == '1'">到时不下线</span>
												<span v-if="item.actity">{{ item.actity }}</span>
											</div>
										</div>
									</router-link>
								</li>
							</ul>
						</van-list>
					</van-tab>
					<div slot="nav-right" class="list-sort" v-if="isShowSort">
						<div class="sort-content">
							<span>排序：</span>
							<span>{{ sortTitle }}</span>
						</div>
						<div class="switch-sort" @click="(switchSortShow = true)">
							<i></i>
							<span>切换</span>
						</div>
					</div>
				</van-tabs>
				<div v-if="copyrightType == 1" class="copyright">
					Copyright &copy; 2018-2020 zugehao.com All Right Reserved
					<br />
					杭州创哈网络科技有限公司(www.zugehao.com)版权所有
					<br />
					浙ICP备 19004405号-2
					<br />
					<div class="hrefBox">
						<span @click="goUrl(1)">《用户协议》</span>
						<span @click="goUrl(2)">《隐私协议》</span>
					</div>
					开发者名称：武汉诸相网络科技有限公司
					<br />
					版本：2.8.0
					<br />
				</div>
				<div v-if="copyrightType == 2" class="copyright">
					Copyright &copy; 2017-2020 All Right Reserved
					<br />
					杭州虚贝科技有限公司 版权所有
					<br />
					浙ICP备2022032879号
					<br />
					浙公网安备 33011002015387号
					<br />
					客服电话：027-65528846
					<div class="hrefBox">
						<span @click="goUrl(1)">《用户协议》</span>
						<span @click="goUrl(2)">《隐私协议》</span>
					</div>
					开发者名称：杭州虚贝科技有限公司
					<br />
					版本：2.8.0
					<br />
				</div>
				<div v-if="copyrightType == 3" class="copyright">
					Copyright &copy; 2017-2022 ugpaly.com All Right Reserved
					<br />
					武汉竹柳科技有限公司 (ugpaly.com) 版权所有
					<br />
					鄂ICP备 鄂ICP备2022004861号-1
					<br />
					浙公网安备 33010302003346号
					<br />
					客服电话：027-65528846
					<div class="hrefBox">
						<span @click="goUrl(1)">《用户协议》</span>
						<span @click="goUrl(2)">《隐私协议》</span>
					</div>
					开发者名称：武汉竹柳科技有限公司
					<br />
					版本：3.3.1
					<br />
					<p class="aboutUs">
						<span @click="goUrl(3)">公司简介</span>
						<span @click="goUrl(4)">联系我们</span>
					</p>
				</div>
				<div v-if="copyrightType == 4" class="copyright">
					Copyright &copy; 2018-2020 zuhw.njweisid.cn All Right Reserved
					<br />
					南京唯思登教育科技有限公司(zuhw.njweisid.cn)版权所有
					<br />
					<div class="hrefBox">
						<span @click="goUrl(1)">《用户协议》</span>
						<span @click="goUrl(2)">《隐私协议》</span>
					</div>
					版本：2.8.0
					<br />
				</div>
				<div v-if="copyrightType == 5" class="copyright">
					Copyright &copy; 2017-2022 ugpaly.com All Right Reserved
					<br />
					武汉竹柳科技有限公司 (ugpaly.com) 版权所有
					<br />
					鄂ICP备2022004861号-1
					<br />
					客服电话：027-65528846
					<div class="hrefBox">
						<span @click="goUrl(1)">《用户协议》</span>
						<span @click="goUrl(2)">《隐私协议》</span>
					</div>
					开发者名称：武汉竹柳科技有限公司
					<br />
					版本：2.8.0
					<br />
				</div>
			</div>
		</div>

		<!--menu-->
		<menu-foot current="index"></menu-foot>
		<!-- 下载虚贝APP弹窗 -->
		<div class="xubei_download" v-if="isDownload">
			<div class="xubei_download_body">
				<div class="xubei_download_top">
					<div class="xubei_download_close" @click="closeDownload">×</div>
				</div>
				<div class="xubei_download_text">此功能需访问虚贝APP</div>
				<div class="xubei_download_bot">
					<div class="xubei_download_btn1" @click="closeDownload">继续逛逛</div>
					<div class="xubei_download_btn2" @click="openDownload">下载虚贝APP</div>
				</div>
			</div>
		</div>
		<!-- dialog -->
		<div class="dialog_pop" v-if="isShowPop2">
			<div :class="['contentNew', { oldUser: configPrizeData.userType == 11 }]" @click="openApp">
				<div class="modal_body">
					<div class="modal_text_01">专属租号红包</div>
					<div class="modal_time">{{ countdown }}</div>
					<div class="modal_text_02">¥2</div>
					<div class="modal_text_03">已发放至「我的—我的优惠券」</div>
				</div>
			</div>
			<div class="closeNew" @click="closeDialogPop2" />
		</div>
		<div class="dialog_pop" v-if="isShowPop">
			<div :class="['content', { oldUser: configPrizeData.userType == 11 }]" @click="goWelfareUrl" />
			<div class="close" @click="closeDialogPop" />
		</div>
		<!-- 新人浮窗 -->
		<div class="floatingWindow" v-if="isNewPeople">
			<img @click="gonewPeopleActivity" class="newPeople" src="../../images/home/newPeople.png" alt="" />
			<img @click="closeBt" class="closeBt" src="../../images/home/closeBt.svg" />
		</div>
		<div class="floatingWindow" v-if="isNewPeople2">
			<img @click="openApp" class="newPeople" src="../../images/home/newUser.png" alt="" />
			<img @click="closeBt2" class="closeBtNew" src="../../images/active/close.png" />
		</div>

		<van-popup v-model="switchSortShow" position="bottom" class="switch-sort-popup">
			<ul>
				<li :class="item.id == priceOrderBy && 'active'" v-for="item in sortList" :key="item.id" @click="selectSort(item)">
					<span>{{ item.content }}</span>
					<van-icon name="success" v-if="item.id == priceOrderBy" />
				</li>
			</ul>
		</van-popup>
	</div>
</template>

<script>
import headerTop from '../../components/header/header';
import menuFoot from '../../components/menu/menu.vue';
import { queryBanner, getCategoryList, rentPage, findLogoByCategory, getHomeGame, queryGoodsList, getImportantParam, getBoonCenter, getConfigPrize } from '../../service/getData';
import Swiper from 'swiper';
import { List, Cell, Tab, Tabs } from 'vant';
import 'swiper/dist/css/swiper.min.css';
import { EventReport } from '../../util/eventReport';
import { createIntersectionObserver } from '../../util/index.js';

const sortList = [
	{
		id: 0,
		content: '低价排序：商品价格从低到高'
	},
	{
		id: 1,
		content: '高价排序：商品价格从高到低'
	},
	{
		id: -1,
		content: '推荐排序：综合因素排序'
	}
];

export default {
	name: 'home',
	data: function () {
		return {
			isDownload: false,
			channel: '',
			bannerList: [],
			openid: this.$route.query.openId,
			gameList: [],
			categoryList: [],
			categoryActive: '',
			tabList: [],
			tabListOrg: [],
			gameList: [],
			gameActive: '',
			tabsActive: '',
			loading: false,
			finished: false,
			// 首页加载列表请求3次数据，为了可见org域名下的隐私协议
			listCount: 1,
			goodsList: [],
			protoParams: [],
			pageIndex: 1,
			pageSize: 10,
			isFixeds: false,
			offsetTop: '',
			style: {
				'min-height': document.body.clientHeight + 'px'
			},
			Android: false,
			ios: false,
			boonCenterData: [],
			configPrizeData: {
				userType: ''
			},
			isShowPop: false,
			isShowPop2: false,
			isNewPeople: false,
			isNewPeople2: false,
			countdown: '距离失效24:00:00', //倒计时
			countdownInterval: '', //定时器
			currentTime: 24 * 60 * 60 * 1000 - 1, //时间戳
			isORG: false,
			isORGLogo: false,
			myObserver: '',
			switchSortShow: false,
			sortList: sortList,
			priceOrderBy: 0, //金额排序，0升序，1降序 -1 综合排序
			channel: this.$store.state.channel || this.$store.state.businessNo
		};
	},
	computed: {
		logo() {
			let href = window.location.href;
			if (href.includes('xubei.org')) {
				return 0;
			} else if (href.includes('zhw.whysjiaoyu') || href.includes('zhw.yunijy')) {
				return 1;
			}
		},
		copyrightType() {
			let href = window.location.href;
			if (href.includes('zugehao')) {
				return 1;
			} else if (href.includes('xubei')) {
				return 2;
			} else if (href.includes('hezuge')) {
				return 3;
			} else if (href.includes('zuhw.njweisid.cn')) {
				return 4;
			} else if (href.includes('ugpaly')) {
				//ugpaly
				return 5;
			}
		},
		gameListFilter() {
			return this.gameList.map((v) => {
				let content = v.content;
				if (content.length >= 8) {
					v.content = content.slice(0, 8);
				} else if (content.length >= 4) {
					v.content = content.slice(0, 4);
				}
				return v;
			});
		},
		newBannerList() {
			return this.bannerList.map((i) => {
				i.index < 3;
			});
		},
		sortTitle() {
			let index = this.sortList.findIndex((item) => {
				return item.id == this.priceOrderBy;
			});
			if (index != -1) {
				return this.sortList[index].content.slice(0, 4);
			} else {
				return '';
			}
		},
		isShowSort() {
			return ['xunyou_h5'].includes(this.channel);
		}
	},
	components: {
		headerTop,
		menuFoot,
		vanList: List,
		vanTab: Tab,
		vanTabs: Tabs
	},
	watch: {
		goodsList: {
			handler: function (newVal, oldVal) {
				if (newVal != oldVal && newVal.length > 0) {
					let arr = [];
					if (newVal.length > oldVal.length) {
						arr = newVal.filter((item) => !oldVal.includes(item));
					}
					this.$nextTick(() => {
						let targetElement = document.querySelectorAll('.shop_list li');
						if (arr.length > 0) {
							targetElement = Array.from(targetElement).filter((item, index) => item.getAttribute('data-goosId') != arr[index].goods_id);
						}
						this.myObserver = createIntersectionObserver(targetElement, 'data-index', (index, goodId, gameId) => {
							let params = {
								business: {
									actionId: 'Top_load',
									gameId,
									businessType: 1,
									position: index,
									goodId
								},
								page: {
									pageId: '首页列表'
								}
							};
							EventReport(params);
						});
					});
				}
			},
			deep: true
		}
	},
	mounted() {
		//红包定时器
		this.countdownInterval = setInterval(() => {
			this.showtime(this.currentTime);
			this.currentTime = (this.currentTime / 1000 - 1) * 1000;
		}, 1000);
		let self = this;

		//如果是来源wifi万能钥匙微信支付 跳转wifi万能钥匙成功页面
		if (this.$route.query.source == 'wifipay') {
			window.location.href = 'http://wifi.xubei.com/paySuccess?order_no=' + self.wifi_order;
		}
		if (this.$route.query.openId) {
			localStorage.openid = this.$route.query.openId;
		} else {
			this.$isWX();
		}

		let data = {
			appKey: 'app_xubei'
		};

		if (window.location.href.includes('xubei.org')) {
			this.isORG = true;
			this.logo = 0;
			// this.temp = '../../images/orgChannelLogo.png'
		}
		if (window.location.href.includes('zhw.whysjiaoyu') || window.location.href.includes('zhw.yunijy')) {
			this.isORG = true;
			this.logo = 1;
		}

		this.getCategoryList();
		this.getRecommendGameList();
		this.getHomeGame();
		this.getBoonCenter();

		queryBanner().then((res) => {
			self.bannerList = res.data.result;
			setTimeout(function () {
				var mySwiper = new Swiper('.swiper-banner', {
					loop: true,
					pagination: '.swiper-pagination',
					autoplay: 3000,
					paginationClickable: true
				});
			}, 500);
		});

		//存储渠道号
		if (this.$route.query.source) {
			localStorage.setItem('source', this.$route.query.source);
		}
		let system = navigator.userAgent;
		this.Android = system.indexOf('Android') > -1 || system.indexOf('Linux') > -1; //android终端或者uc浏览器
		this.ios = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端\

		// 获取新人活动
		this.getConfigPrize();
		// 新人浮窗显示规则
		this.isShowFloating();
	},
	methods: {
		//红包定时器
		showtime(intervalTime) {
			let time = intervalTime;
			if (time <= 0) {
				clearInterval(this.countdownInterval);
				this.countdown = '已失效';
				return false;
			}
			let H = Math.floor((time / 1000 / 60 / 60) % 24).toString(),
				M = Math.floor((time / 1000 / 60) % 60).toString(),
				S = Math.floor((time / 1000) % 60).toString();
			H = H >= 10 ? H : `0${H}`;
			M = M >= 10 ? M : `0${M}`;
			S = S >= 10 ? S : `0${S}`;
			this.countdown = `距离失效${H}:${M}:${S}`;
		},
		goUrl(type) {
			if (type == 1) {
				this.$router.push({
					path: 'servicesDetail'
				});
			} else if (type == 2) {
				this.$router.push({
					path: 'privacys'
				});
			} else if (type == 3) {
				this.$router.push({
					path: 'companyProfile'
				});
			} else if (type == 4) {
				this.$router.push({
					path: 'contactUs'
				});
			}
		},
		async getConfigPrize() {
			// 用户已关闭
			if (JSON.parse(sessionStorage.getItem('isHidePop'))) {
				return false;
			}
			// 用户未登录
			if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
				this.isShowPop = true;
			}
			let params = {
				Authorization: this.$store.state.userInfo.authorization,
				appChannel: this.$store.state.channel || this.$store.state.businessNo
			};

			const { data } = await getConfigPrize(params);
			if (data.code == '1' && data.success) {
				this.configPrizeData = data.result;
				if (data.result.userType == 10 || data.result.userType == 11) {
					this.isShowPop = true;
				}
			}
		},
		// cms配置福利中心
		getBoonCenter() {
			let url = window.location.host;

			getBoonCenter(url).then((res) => {
				let arr = res.data.result;
				arr.map((item) => {
					item.actionUrl = item.actionUrl.replace('domainUrl', window.location.host);
				});

				arr.sort(function (a, b) {
					return a.place - b.place;
				});
				this.boonCenterData = arr;
			});
		},
		// 获取类目列表数据
		getCategoryList() {
			getCategoryList({ channel: this.$store.state.businessNo })
				.then((res) => {
					if (res.data.code == '1') {
						this.categoryList = res.data.result;
					}
				})
				.catch((err) => {
					this.$toast(err.message || '获取游戏类目失败');
				});
		},
		// 获取推荐类目的游戏列表
		async getRecommendGameList() {
			const { data } = await rentPage();
			if (data.code == 1 && data.result.length > 0) {
				this.tabList = data.result[0].content.slice(0, 5);
				this.tabListOrg = data.result[0].content.slice(0, 9);
			}
		},
		// 切换类目
		checkCategoryActive(index, id) {
			this.categoryActive = index;
			// 获取当前类目下的游戏
			if (index == 0) {
				this.getRecommendGameList();
			} else {
				this.findLogoByCategory(id);
			}
		},
		// 根据类目查找游戏
		async findLogoByCategory(id) {
			let params = {
				gameCategoryId: id
			};
			const { data } = await findLogoByCategory(params);
			if (data.code == 1) {
				this.tabList = data.result.hotGames.slice(0, 5);
				this.tabListOrg = data.result.hotGames.slice(0, 9);
			}
		},
		// 获取推荐的四款游戏
		async getHomeGame() {
			const { data } = await getHomeGame();
			if (data.code == 1) {
				this.gameList = data.result;
				this.gameActive = data.result[0].gameId;
				await this.getImportantParam();
			} else {
				this.$toast(data.message || '获取游戏列表失败');
			}
		},
		getImportantParam() {
			let data = {
				gameId: this.gameActive, // 区服名称
				channel: this.$store.state.businessNo
			};
			getImportantParam(data)
				.then((res) => {
					this.protoParams = res[0].importantParam;
				})
				.catch((err) => {});
		},
		// 切换游戏
		async checkGameActive(name, title) {
			this.gameList.filter((item) => {
				if (item.title == title) {
					this.gameActive = item.gameId;
				}
			});
			this.goodsList = [];
			this.pageIndex = 1;
			this.listCount = 1;
			this.loading = true;
			this.finished = false;
			this.priceOrderBy = 0;
			await this.getImportantParam();
			if (this.loading) {
				this.queryGoodsList();
			}
		},
		// 获取出租商品
		async queryGoodsList() {
			if (!this.gameActive || this.listCount == 3) {
				// 没有游戏id跳出
				this.loading = false;
				return false;
			}
			let gameType = null;
			// 计算游戏是否手游，手游添加ststem字段
			this.gameList.map((item) => {
				if (this.gameActive == item.gameId) {
					gameType = item.gameType;
				}
			});
			let params = {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
				gameId: this.gameActive,
				businessNo: this.$store.state.businessNo,
				system: gameType == 2 && this.Android ? '0' : gameType == 2 && this.ios ? '1' : ''
			};
			if (this.priceOrderBy != -1 && this.isShowSort) {
				params.priceOrderBy = this.priceOrderBy;
			}
			const { data } = await queryGoodsList(params);
			if (data.result.list.length < 9) {
				// 没数据了，结束触底加载
				this.finished = true;
			}
			if (data.code == '1') {
				this.goodsList = this.goodsList.concat(data.result.list);
				this.pageIndex = this.pageIndex + 1;
				this.listCount++;
				this.loading = false;
			}
		},
		// 关闭新人活动弹窗
		closeDialogPop() {
			this.isShowPop = false;
			this.isShowPop2 = false;
			sessionStorage.setItem('isHidePop', true);
		},
		closeDialogPop2() {
			this.isShowPop2 = false;
		},
		goWelfareUrl() {
			sessionStorage.setItem('isHidePop', true);

			if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
				this.$router.push({
					path: '/login',
					query: {
						redirect: `/welfare?channel=${this.$store.state.channel || this.$store.state.businessNo}&clientId=6`
					}
				});
				return false;
			}
			this.$router.push({
				path: '/welfare',
				query: {
					channel: this.$store.state.channel || this.$store.state.businessNo,
					clientId: 6
				}
			});
		},
		//点击新的红包弹窗，判断是否安装app，已安装则唤起app，未安装则跳转下载链接
		openApp() {
			let system = navigator.userAgent;
			let isAndroid = system.indexOf('Android') > -1 || system.indexOf('Adr') > -1; //判断是否是 android终端
			let isIOS = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
			if (isAndroid) {
				this.watchVisibility();
				//未唤起APP则弹出下载提示弹窗
				this.timer = setTimeout(() => {
					this.isDownload = true;
				}, 500);
				window.location.href = 'xubeinewapp://'; //Native端配置Scheme：IOS唤起虚贝营地、Android唤起虚贝租号
			} else if (isIOS) {
				this.watchVisibility();
				this.timer = setTimeout(() => {
					this.isDownload = true;
				}, 500);
				window.location.href = 'xubeinewapp://'; //Native端配置Scheme：IOS唤起虚贝营地、Android唤起虚贝租号
			}
		},
		//页面监听
		watchVisibility() {
			window.addEventListener('visibilitychange', () => {
				if (document.hidden) {
					// 如果页面隐藏了，则表示唤起成功，清除下载弹窗定时器
					clearTimeout(timer);
				}
			});
		},
		openDownload() {
			window.location.href = 'https://static.xubei.com/act/download0418/downloadH5New.html?source=h5&channel=' + this.$route.query.channel + '&userId=';
		},
		closeDownload() {
			this.isDownload = false;
		},
		// 关闭浮窗
		closeBt() {
			this.isNewPeople = false;
		},
		closeBt2() {
			this.isNewPeople2 = false;
		},
		// 点击新人浮窗
		gonewPeopleActivity() {
			if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
				this.$router.push({
					path: '/login',
					query: {
						redirect: `/welfare?channel=${this.$store.state.channel || this.$store.state.businessNo}&clientId=6`
					}
				});
				return false;
			}
			this.$router.push({
				path: '/welfare',
				query: {
					channel: this.$store.state.channel || this.$store.state.businessNo,
					clientId: 6
				}
			});
		},
		//浮窗显示规则
		async isShowFloating() {
			//渠道号为channel=Android_huodong_h5时，拉起新的红包弹窗
			if (this.$route.query.channel && this.$route.query.channel == 'Android_huodong_h5') {
				this.isNewPeople2 = true;
				this.isShowPop2 = true;
				this.isNewPeople = false;
				this.isShowPop = false;
			} else {
				if (this.$store.state.userInfo && this.$store.state.userInfo.authorization) {
					let params = {
						Authorization: this.$store.state.userInfo.authorization,
						appChannel: this.$store.state.channel || this.$store.state.businessNo
					};
					const { data } = await getConfigPrize(params);
					if (data.code == '1' && data.success) {
						this.configPrizeData = data.result;
						if (data.result.userType == 10) {
							this.isNewPeople = true;
						}
					}
				} else {
					this.isNewPeople = true;
				}
			}
		},
		selectSort(item) {
			this.priceOrderBy = item.id;
			this.switchSortShow = false;
			this.pageIndex = 1;
			this.pageSize = 10;
			this.goodsList = [];
			this.listCount = 1;
			this.loading = true;
			this.finished = false;
			this.queryGoodsList();
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../../style/common';

input::-webkit-input-placeholder {
	color: #fff !important;
}

.registerModal {
	position: fixed;
	width: 100%;
	height: px2rem(1334rem);
	background: rgba(0, 0, 0, 0.3);
	z-index: 10;

	.pageModal {
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 11;
		text-align: center;
		transform: translate(-50%, -50%);
		-webkit-transform: translate(-50%, -50%);

		.registerOk {
			width: px2rem(620rem);
			height: px2rem(460rem);
			background: url(../../images/rebate/register_ok.png) no-repeat;
			background-size: 100% 100%;
			padding-top: px2rem(257rem);

			p {
				font-size: px2rem(26rem);
				line-height: px2rem(36rem);
				color: #e8a05f;
			}

			.lease_button {
				margin-top: px2rem(40rem);
				display: inline-block;
				background: url(../../images/rebate/lease_button.png) no-repeat;
				background-size: 100% 100%;
				width: px2rem(485rem);
				height: px2rem(77rem);
			}
		}

		.register_closed {
			background: url(../../images/rebate/register_closed.png) no-repeat;
			background-size: 100% 100%;
			height: px2rem(52rem);
			width: px2rem(52rem);
			position: fixed;
			left: 50%;
			bottom: px2rem(-70rem);
			margin-left: px2rem(-26rem);
		}
	}
}

.header-top {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	background: linear-gradient(360deg, #51b3ff 0%, #1979f0 100%);
	line-height: px2rem(88rem);
	z-index: 999;
	padding: 0 px2rem(20rem);
	display: flex;
	justify-content: start;
	align-items: center;

	.channelLogo {
		width: 1.14rem;
		height: 0.42rem;
	}

	.searchinput {
		line-height: px2rem(56rem);
		background: rgba(255, 255, 255, 0.4);
		border-radius: 15px;
		width: px2rem(550rem);
		margin: 0 px2rem(20rem);
		color: #fff;
		padding-left: px2rem(50rem);
		outline: none;
	}

	.searchinputOrg {
		width: px2rem(520rem);
		line-height: px2rem(56rem);
		background: rgba(255, 255, 255, 0.4);
		border-radius: 15px;
		margin: 0 px2rem(20rem);
		color: #fff;
		padding-left: px2rem(50rem);
		outline: none;
	}

	.searchinput::-webkit-input-placeholder {
		font-size: px2rem(30rem);
		font-weight: 400;
		color: rgba(255, 255, 255, 0.4);
		line-height: px2rem(56rem);
	}

	a {
		i {
			display: inline-block;
			vertical-align: middle;
			width: px2rem(48rem);
			height: px2rem(48rem);
			margin-top: -4px;
		}

		.noticeIcon {
			background: url('../../images/home/noticeIcon.png') no-repeat center center;
			background-size: px2rem(48rem) px2rem(48rem);
		}

		.serverIcon {
			background: url('../../images/home/serverIcon.png') no-repeat center center;
			background-size: px2rem(48rem) px2rem(48rem);
		}
	}

	.icont {
		position: absolute;
		left: px2rem(100rem);
		top: 50%;
		transform: translate(0, -50%);
		color: rgba(255, 255, 255, 1);
		font-size: px2rem(30rem);
		padding-left: px2rem(10rem);
	}

	.icontOrg {
		position: absolute;
		top: 50%;
		transform: translate(0, -50%);
		color: rgba(255, 255, 255, 1);
		font-size: px2rem(30rem);
		padding-left: px2rem(10rem);
		left: px2rem(160rem);
	}
}

.home {
	padding-bottom: px2rem(124rem);
	padding-top: px2rem(78rem);

	.banner {
		padding: px2rem(30rem) px2rem(45rem);
		font-size: 0;

		.swiper-container {
			width: px2rem(660rem);
			height: px2rem(240rem);
			border-radius: 10px;
			overflow: hidden;
		}

		img {
			height: px2rem(240rem);
		}
	}

	.categoryList {
		position: relative;
		margin-top: px2rem(30rem);

		.moreIcon {
			position: absolute;
			right: 0;
			top: px2rem(-8rem);
			display: block;
			width: px2rem(75rem);
			height: px2rem(50rem);
			background: url('../../images/home/moreIcon.png') no-repeat center center;
			background-size: px2rem(75rem) px2rem(50rem);
			z-index: 10;
		}

		.tabHeader {
			width: 91%;
			overflow-x: auto;

			ul {
				display: flex;
				align-items: center;

				li {
					position: relative;
					// 文字不换行
					white-space: nowrap;
					color: #999999;
					height: px2rem(60rem);
					font-size: px2rem(28rem);
					line-height: px2rem(60rem);
					margin: 0 px2rem(30rem) px2rem(30rem);

					i {
						display: block;
						position: absolute;
						bottom: px2rem(-4rem);
						left: 50%;
						transform: translateX(-50%);
						width: 100%;
						height: px2rem(8rem);
					}
				}

				.categoryActive {
					color: #111111;
					font-weight: 500;
					font-size: px2rem(34rem);
					line-height: px2rem(60rem);

					i {
						background: linear-gradient(90deg, #5592fc 0%, #6dcfff 100%);
						border-radius: px2rem(6rem);
					}
				}
			}
		}

		.tabBody {
			padding: 0 px2rem(44rem);

			.gameBox {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				flex-wrap: wrap;

				.boxItem {
					display: flex;
					flex-flow: column;
					justify-content: flex-start;
					align-items: center;

					.images {
						width: px2rem(98rem);
						height: px2rem(98rem);
						border-radius: px2rem(16rem);
						overflow: hidden;

						img {
							display: block;
							width: 100%;
							height: 100%;
						}
					}

					.tit {
						width: px2rem(130rem);
						color: #666666;
						font-size: px2rem(26rem);
						line-height: px2rem(34rem);
						margin-top: px2rem(14rem);
						text-align: center;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}
			}
		}
	}

	.boonCenter {
		padding: px2rem(60rem) px2rem(30rem) 0;

		.title {
			font-size: px2rem(34rem);
			color: #111;
			line-height: px2rem(60rem);
			margin-bottom: px2rem(30rem);
		}

		.content {
			display: flex;
			justify-content: space-between;
			align-items: center;

			div {
				position: relative;
				width: px2rem(330rem);
				height: px2rem(200rem);
				border-radius: px2rem(16rem);
				overflow: hidden;

				img {
					width: 100%;
					height: 100%;
					display: block;
				}

				p {
					position: absolute;
					bottom: 0;
					left: 0;
					height: px2rem(50rem);
					width: 100%;
					background: rgba(0, 0, 0, 0.3);
					font-size: px2rem(26rem);
					color: #ffffff;
					line-height: px2rem(50rem);
					text-align: center;
					padding: 0 px2rem(15rem);
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}
	}

	.bannerImgEnter {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: px2rem(15rem);

		.orgChannelImg {
			width: px2rem(702rem);
			height: px2rem(156rem);
		}
	}

	.gameList {
		height: 85vh;
		margin-top: px2rem(20rem);

		/deep/ .van-tabs {
			padding: 0 px2rem(30rem) 0;
			background: #fff;
		}

		/deep/ .van-tab {
			text-align: center;
		}

		/deep/ .van-tab--active {
			span {
				color: #111 !important;
				font-size: 0.34rem;
			}
		}

		/deep/ .van-sticky--fixed {
			padding: 0 px2rem(30rem) px2rem(8rem);
			background: #fff;
			border-bottom: px2rem(1rem) solid #e7e7e7;
		}

		/deep/ .van-tab__text {
			text-align: center;
			color: #999;
		}

		/deep/ .van-tab__text--ellipsis {
			width: 99%;
			font-size: px2rem(28rem);
			line-height: px2rem(32rem);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			/* autoprefixer: off*/
			-webkit-box-orient: vertical;
			/* autoprefixer: on*/
		}

		/deep/ .van-tabs__line {
			height: px2rem(8rem);
			width: px2rem(42rem);
			bottom: none;
			top: px2rem(84rem);
			background: linear-gradient(90deg, #5592fc 0%, #6dcfff 100%) !important;
		}

		/deep/ .van-tab {
			height: px2rem(92rem);
		}

		/deep/ .van-list__finished-text {
			color: #d7d7d7;
		}
		/deep/ .van-tabs__wrap {
			height: px2rem(92rem);
		}
		/deep/ .sort-tabs {
			.van-sticky {
				.van-tabs__wrap {
					height: px2rem(182rem);
				}
			}
		}
		.list-sort {
			width: 100%;
			height: px2rem(90rem);
			background: #ffffff;
			position: absolute;
			top: px2rem(92rem);
			left: 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			span {
				font-size: px2rem(28rem);
				color: #999999;
				line-height: 34px;
			}
			.sort-content {
				span {
					&:nth-of-type(2) {
						padding: px2rem(10rem) px2rem(12rem);
						background: #f0f9ff;
						border-radius: px2rem(10rem);
						color: #3eaffd;
					}
				}
			}
			.switch-sort {
				i {
					display: inline-block;
					width: px2rem(24rem);
					height: px2rem(24rem);
					background: url('../../images/home/switch-sort.png') no-repeat;
					background-size: 100% 100%;
				}
			}
		}

		.shop_list {
			background: $c_ff;
			padding-bottom: px2rem(100rem);

			li {
				border-bottom: 1px solid #ededed;
				padding: px2rem(30rem) 0;
			}

			li:last-child {
				margin-bottom: 0;
			}

			li > a {
				display: flex;

				.img {
					display: flex;
					flex-flow: column;
					justify-content: flex-start;
					align-items: center;
					position: relative;
					width: px2rem(160rem);
					margin-right: px2rem(20rem);

					img {
						display: block;
						@include borderRadius(10px);
						width: px2rem(160rem);
						height: px2rem(160rem);
						margin-bottom: px2rem(10rem);
					}

					.game_login_type {
						width: 100%;
						font-size: px2rem(24rem);
						line-height: px2rem(24rem);
						font-weight: 400;
						text-align: center;
						padding: px2rem(8rem) 0;
						color: #ff5137;
						background: #ffedeb;
						@include borderRadius(5px);
					}

					.loginTypeQQ,
					.loginTypeWx {
						display: block;
						position: absolute;
						top: 0;
						left: 0;
						width: px2rem(32rem);
						height: px2rem(32rem);
					}

					.loginTypeQQ {
						background: url('../../images/goodsList/qqIcon.png') no-repeat center center;
						background-size: px2rem(32rem) px2rem(32rem);
					}

					.loginTypeWx {
						background: url('../../images/goodsList/wxIcon.png') no-repeat center center;
						background-size: px2rem(32rem) px2rem(32rem);
					}
				}

				.inner {
					flex: 1;

					.game_name {
						color: #333;
						font-size: px2rem(28rem);
						line-height: px2rem(40rem);
						max-height: px2rem(80rem);
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						/*3表示只显示3行*/
						/* autoprefixer: off */
						-webkit-box-orient: vertical;

						/* autoprefixer: on */
						// span {
						//   background-image: linear-gradient(-225deg, #ffa114 0%, #ff8209 100%);
						//   border-radius: 6px;
						//   color: #fff;
						//   font-size: px2rem(25rem);
						//   width: px2rem(36rem);
						//   height: px2rem(36rem);
						//   line-height: px2rem(36rem);
						//   text-align: center;
						//   display: inline-block;
						//   margin-right: px2rem(5rem);
						// }
						span {
							display: inline-block;
							width: px2rem(27rem);
							height: px2rem(34rem);
							vertical-align: top;
						}

						.stickorderIcon {
							background: url('../../images/goodsList/top.png') no-repeat center center;
							background-size: px2rem(27rem) px2rem(34rem);
						}

						.isCompensateIcon {
							background: url('../../images/goodsList/pei.png') no-repeat center center;
							background-size: px2rem(27rem) px2rem(34rem);
						}
					}

					.game_area {
						font-size: px2rem(26rem);
						color: #999;
						text-overflow: ellipsis;
						margin-top: px2rem(8rem);
						max-height: 0.64rem;
						overflow: hidden;
					}

					.protoParams {
						margin-top: px2rem(14rem);

						span {
							display: inline-block;
							font-size: px2rem(20rem);
							line-height: normal;
							border-radius: px2rem(8rem);
							padding: px2rem(2rem) px2rem(10rem) px2rem(1rem);
							margin-right: px2rem(20rem);
							margin-bottom: px2rem(14rem);
						}
					}

					.protoParams span:nth-child(1) {
						color: #3eaffd;
						border: 1px solid #3eaffd;
					}

					.protoParams span:nth-child(2) {
						color: #ff5137;
						border: 1px solid #ff5137;
					}

					.protoParams span:nth-child(3) {
						color: #ff9b00;
						border: 1px solid #ff9b00;
					}

					.game_price {
						display: flex;
						margin-top: px2rem(10rem);
						color: $c_blue;

						.lf {
							flex: 1;
							line-height: px2rem(60rem);
							color: #999999;
							font-size: px2rem(20rem);

							i {
								font-style: normal;
								color: #ff5137;
							}

							em {
								font-style: normal;
								font-size: px2rem(40rem);
								color: #ff5137;
								font-weight: 500;
							}
						}

						.hot_value {
							margin-top: 1px;
							line-height: px2rem(64rem);
							font-size: px2rem(20rem);
							color: #cbcbcb;
						}
					}

					.activity {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						flex-wrap: wrap;

						// margin-top: px2rem(10rem);
						span {
							font-size: px2rem(20rem);
							font-weight: 400;
							color: #3eaffd;
							line-height: normal;
							padding: px2rem(4rem) px2rem(4rem);
							background: #f0f9ff;
							border-radius: px2rem(10rem);
							margin-right: px2rem(10rem);
							margin-bottom: px2rem(10rem);
						}
					}

					.activity span:last-child {
						margin-right: 0;
					}
				}
			}
		}

		.copyright {
			padding: 14px 0 80px 0;
			text-align: center;
			color: #bbb;
			margin-bottom: 60px;

			div {
				margin-top: 4px;

				span {
					color: #bbb;
				}
			}

			.aboutUs {
				font-size: 0.2rem;
				color: #3eaffd;
				line-height: 0.2rem;
				margin-top: 0.24rem;

				> span {
					text-decoration: underline;

					&:first-of-type {
						margin-right: 0.6rem;
					}
				}
			}
		}
	}
}

.router-fade-enter-active,
.router-fade-leave-active {
	transition: opacity 0.1s;
}

.router-fade-enter,
.router-fade-leave-active {
	opacity: 0;
}

.xubei_download {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.6);
	z-index: 1001;

	.xubei_download_body {
		position: relative;
		top: px2rem(550rem);
		left: 50%;
		transform: translateX(-50%);
		width: px2rem(538rem);
		height: px2rem(266rem);
		border-radius: px2rem(26rem);
		background: #ffffff;
		display: flex;
		flex-direction: column;
		align-items: center;

		.xubei_download_top {
			width: px2rem(498rem);
			height: px2rem(48rem);
			display: flex;
			justify-content: flex-end;
			align-items: center;

			.xubei_download_close {
				font-size: px2rem(48rem);
				color: #adadad;
			}
		}

		.xubei_download_text {
			font-size: px2rem(30rem);
			margin-top: px2rem(22rem);
			color: #666666;
		}

		.xubei_download_bot {
			width: px2rem(480rem);
			margin-top: px2rem(42rem);
			display: flex;
			justify-content: space-between;
			align-items: center;

			.xubei_download_btn1 {
				display: flex;
				justify-content: center;
				align-items: center;
				border: 1px solid #3eaffd;
				border-radius: px2rem(30rem);
				width: px2rem(200rem);
				height: px2rem(60rem);
				color: #3eaffd;
				font-size: px2rem(26rem);
			}

			.xubei_download_btn2 {
				display: flex;
				justify-content: center;
				align-items: center;
				background: #3eaffd;
				border-radius: px2rem(30rem);
				width: px2rem(200rem);
				height: px2rem(60rem);
				color: #ffffff;
				font-size: px2rem(26rem);
			}
		}
	}
}
</style>

<style lang="scss" scoped>
@import '../../style/common';

.dialog_pop {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.6);
	z-index: 1000;

	.content {
		position: relative;
		top: px2rem(350rem);
		left: 50%;
		transform: translateX(-50%);
		width: px2rem(538rem);
		height: px2rem(690rem);
		background: url('~@/images/active/newuser.png') no-repeat center center;
		background-size: px2rem(538rem) px2rem(690rem);
	}

	.contentNew {
		position: relative;
		top: px2rem(350rem);
		left: 50%;
		transform: translateX(-50%);
		width: px2rem(538rem);
		height: px2rem(690rem);
		background: url('~@/images/active/newModal.png') no-repeat center center;
		background-size: px2rem(538rem) px2rem(690rem);
	}

	.oldUser {
		background: url('~@/images/active/olduser.png') no-repeat center center !important;
		background-size: px2rem(538rem) px2rem(690rem) !important;
	}

	.close {
		position: relative;
		top: px2rem(400rem);
		left: 50%;
		transform: translateX(-50%);
		width: px2rem(52rem);
		height: px2rem(52rem);
		background: url('~@/images/active/close.png') no-repeat center center;
		background-size: px2rem(52rem) px2rem(52rem);
	}

	.closeNew {
		position: relative;
		top: px2rem(-320rem);
		left: 81%;
		transform: translateX(-50%);
		width: px2rem(52rem);
		height: px2rem(52rem);
		background: url('~@/images/active/close.png') no-repeat center center;
		background-size: px2rem(52rem) px2rem(52rem);
	}
}

.modal_body {
	padding-top: 43%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.modal_text_01 {
		font-size: px2rem(40rem);
		font-family: Medium;
		font-weight: 550;
		color: #333333;
		line-height: px2rem(60rem);
		letter-spacing: 1px;
	}

	.modal_text_02 {
		font-size: px2rem(70rem);
		font-family: Medium;
		font-weight: bold;
		color: #ff5137;
		line-height: px2rem(105rem);
		letter-spacing: 1px;
	}

	.modal_text_03 {
		font-size: px2rem(24rem);
		font-family: Bold Bold;
		margin-top: px2rem(6rem);
		font-weight: 400;
		color: #666666;
		line-height: px2rem(36rem);
	}

	.modal_time {
		font-size: px2rem(24rem);
		font-family: Normal;
		font-weight: 500;
		color: #ff5137;
		line-height: px2rem(36rem);
		margin-top: px2rem(6rem);
	}
}

.floatingWindow {
	position: fixed;
	left: 50%;
	bottom: px2rem(98rem);
	z-index: 30;
	height: px2rem(128rem);
	width: px2rem(750rem);
	transform: translateX(-50%);

	.newPeople {
		height: px2rem(128rem);
		width: px2rem(750rem);
	}

	.closeBt {
		position: absolute;
		right: px2rem(46rem);
		top: px2rem(-40rem);
		width: px2rem(36rem);
		height: pxren(36rem);
	}

	.closeBtNew {
		position: absolute;
		left: px2rem(10rem);
		top: px2rem(40rem);
		width: px2rem(42rem);
		height: pxren(42rem);
	}
}

.switch-sort-popup {
	background: #ffffff;
	padding: px2rem(30rem) px2rem(48rem) px2rem(60rem);
	ul {
		li {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-weight: 400;
			font-size: px2rem(28rem);
			color: #333333;
			line-height: px2rem(34rem);
			&:not(:first-of-type) {
				margin-top: px2rem(60rem);
			}
		}
		.active {
			color: #3eaffd;
			.van-icon {
				color: #3eaffd;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue